var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubePortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2218_7363",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8626 24.3202C51.3891 24.7285 52.5961 25.9354 53.0044 27.4619C53.7499 30.2309 53.7499 35.9997 53.7499 35.9997C53.7499 35.9997 53.7499 41.7684 53.0044 44.5374C52.5961 46.0639 51.3891 47.2709 49.8626 47.6791C47.0936 48.4246 35.9999 48.4246 35.9999 48.4246C35.9999 48.4246 24.9062 48.4246 22.1372 47.6791C20.6107 47.2709 19.4037 46.0639 18.9955 44.5374C18.25 41.7684 18.25 35.9997 18.25 35.9997C18.25 35.9997 18.25 30.2309 18.9955 27.4619C19.4037 25.9354 20.6107 24.7285 22.1372 24.3202C24.9062 23.5747 35.9999 23.5747 35.9999 23.5747C35.9999 23.5747 47.0936 23.5747 49.8626 24.3202ZM32.45 30.6751V41.3251L41.6799 36.0001L32.45 30.6751Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2218_7363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 39.9998,
    height: 39.9999,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePortfolio);
export default __webpack_public_path__ + "static/media/youtube_portfolio.d4cfc9343e060d7dc01c37fc851f6b81.svg";
export { ForwardRef as ReactComponent };